export class RequestInsertDiaInhabil {
    public fechaInicioStruct: any; // Formato 'YYYY-MM-DD'
    public fechaFinStruct: any; // Formato 'YYYY-MM-DD'
    public horaInicio!: string; // Formato 'HH:MM'
    public horaFin!: string; // Formato 'HH:MM'
    public motivo!: string; // Detalle del día inhábil
    public fechaInicio!: Date; // Formato 'YYYY-MM-DD'
    public fechaFin!: Date; // Formato 'YYYY-MM-DD'
    public IdTipoOrgOIJ!: number; // Id del tipo de organismo
    public IdOIJ!: number; // Id del organismo
    public IdOIJReg!: number; // Id del organismo que registra
    public IdOIJBaja!: number; // Id del organismo que da de baja 
}


export class DiasInhabilesDTO {
    public idConfigDiasInhabiles!: number;
    public tipoOrganismoIdIOJ!: number;
    public ioij!: number;
    public motivo!: string;
    public fechaIncio!: string;
    public fechaFin!: string;
    public estatus!: number;
    public organoAutoridad!: string;
    public estado!: Estado;
    public guidRel!: string;

}

export enum Estado{
    Vencido = 0,
    Vigente = 1,
    Pendiente = 2
}

export class RegDiaInhabilcommand {
    public TipoOrganismoIdIOJ!: number;
    public IOIJ!: number;
    public sMotivo !: string;
    public fechaIncio !: string;
    public fechaFin !: string;
    public OIJregistra!: number;
    public guidRel!: string;
}

export class BajaDiaInhabilcommand {
    public IdConfigDiasInhabiles!: number;
    public IOIJBaja!: number;
}

export class UpdDiaInhabilcommand{
    public TipoOrganismoIdIOJ!: number;
    public IOIJ!: number;
    public sMotivo !: string;
    public fechaIncio !: string;
    public fechaFin !: string;
    public OIJregistra!: number;
    public guidRel!: string;
    public IdConfiguracionDiasInhabiles!: number;
}

export class GetDiasInhabilesFiltradosQuery{
    public TipoOrganismoIdIOJ!: number;
    public Estado!: Estado;
    public FechaInicio !: string;
    public FechaFin !: string;
}